import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Grid, Typography } from '@material-ui/core';

import { useStyles } from '../styles';
import AddOn from './AddOn';

function AddOnsSection(props) {
    const { addOns } = props;
    const classes = useStyles();

    if (isEmpty(addOns) || addOns.length <= 0) {
        return null;
    }

    return (
        <Grid className={classes.addOnsSpace}>
            <Typography
                variant={'body1'}
                weight={'light'}
                className={classes.addOnsHeading}
            >
                <strong>Add Ons:</strong>
            </Typography>
            <div className={classes.addOnsPillRow}>
                {addOns.map((item, i) => (
                    <AddOn key={`addon-${i}`} data={item} />
                ))}
            </div>
        </Grid>
    );
}

AddOnsSection.propTypes = {
    addOns: PropTypes.array,
};

AddOnsSection.defaultProps = {
    addOns: [],
};

export default AddOnsSection;
